import { TLC_CONSTANTS } from "../../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { renderInShadow } from "../../../../../js/lib/components/ShadowUtils";
import { RateAndReview } from "../../../../../js/lib/components/RateAndReview";
import * as React from 'react';

export class FacetsView {
  constructor(options) {
    this.id = LS2PAC_CONSTANTS.Ids.SearchPage.facetsContainer;
    this.listId = LS2PAC_CONSTANTS.Ids.SearchPage.facets;
    this.facetResults = [];
    this.constants = {
      facetItemsListPrefix: "facet_",
      facetAttribute: "data-facet",
      facetSectionTmpl: "tmpl/results/facetsSection.html",
      facetItemsTmpl: "tmpl/results/facetItems.html",
      facetMoreLinkTmpl: "tmpl/results/facetsMoreLink.html",
    };
    this.hasBoundEvents = false;
    this.removeListenerFunctions = [];
    this.addListeners();
  }
  hideFacetsContainer(callback) {
    $("#" + this.id).hide();
  }
  showFacetsContainer(callback) {
    $("#" + this.id).show();
    if (callback) {
      callback();
    }
  }
  renderFacet(facet) {
    var _this = this;
    var container = $(
      "#" + _this.constants.facetItemsListPrefix + facet.facetName
    );
    TemplateEngine.fetch(
      _this.constants.facetItemsTmpl,
      container,
      facet,
      function () {
        if (facet.slideOpen) {
          container.slideDown();
        } else {
          container.show();
        }
        _this.convertFacetToRating(facet, container, "li a");

        if (facet.moreResults) {
          TemplateEngine.fetch(
            _this.constants.facetMoreLinkTmpl,
            container,
            facet
          );
        }
      },
      TemplateEngine.method.overwrite
    );
  }
  renderResults(data) {
    var _this = this;

    this.facetResults = data.facetResults;
    this.showFacetsContainer();

    TemplateEngine.fetch(
      this.constants.facetSectionTmpl,
      this.listId,
      this.facetResults,
      function () {
        $.each(data.facetResults, function (index, facet) {
          if (facet.expand === true) {
            _this.renderFacet(facet);
            $("#" + _this.constants.facetItemsListPrefix + facet.facetName)
              .parent()
              .find("a")
              .addClass(LS2PAC_CONSTANTS.CssClasses.open);
          }
        });
        _this.addEvents();
      },
      TemplateEngine.method.overwrite
    );
  }
  renderBreadCrumbs(facets) {
    var _this = this,
      breadCrumbs = $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.facetBreadCrumbs),
      breadCrumbsContainer = $(
        "#" + LS2PAC_CONSTANTS.Ids.SearchPage.breadCrumbsContainer
      );
    if (facets.length === 0) {
      breadCrumbsContainer.hide();
      breadCrumbs.empty();
    } else {
      TemplateEngine.fetch(
        "tmpl/results/facetBreadCrumbs.html",
        breadCrumbs,
        facets,
        function () {
          breadCrumbsContainer.show();
          

          $.each(facets, function (index, facet) {
            _this.convertFacetToRating(
              facet,
              breadCrumbs,
              `#${facet.facetName}_${facet.facetValue}`
            );
          });
        },
        TemplateEngine.method.overwrite
      );
    }
  }
  convertFacetToRating(facet, container, selector) {
    if (
      facet.facetName.toLowerCase().indexOf("content") == -1 &&
      facet.facetName.toLowerCase().indexOf("rating") > -1
    ) {

      const elements = container[0].querySelectorAll(selector);
      elements.forEach((element) => {
        const rating = parseInt(element.textContent, 10);
        element.innerHTML = '';

        // anchor tags do not support shadowDom so we need to append a div
        const divElement = document.createElement('div');
        element.appendChild(divElement);
        renderInShadow(
          <RateAndReview
            name="rating"
            readonly={true}
            averageRating={rating}
          ></RateAndReview>,
          divElement,
          ApplicationData.language
        );

      });
      
    }
  }
  addListeners() {
    var _this = this;

    this.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (event) {
        if (LS2PacSearchDatabaseManager.getCurrentDatabaseConfig().hasFacets) {
          _this.emptyList(false);
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.emptyList(false);
        $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.breadCrumbsContainer).hide();
        $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.facetBreadCrumbs).empty();
      }
    );

    this.addListener(
      TLC_CONSTANTS.Events.onPagingModelResponse,
      function (event) {
        if (event.success === false || event.data.hasFacets !== true) {
          _this.hideFacetsContainer();
        } else {
          _this.renderBreadCrumbs(event.data.facetFilters);
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onGetFacetResultsResponse,
      function (event) {
        TLCLogger.log("onGetFacetResultsResponse", event.data.facetResults);
        if (event.data.facetResults.length > 0) {
          if ($("#" + _this.id).is(":visible") === false) {
            _this.showFacetsContainer(function () {
              _this.renderResults(event.data);
            });
          } else {
            _this.renderResults(event.data);
          }
        } else {
          _this.emptyList(true);
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onGetMoreFacetResultsResponse,
      function (event) {
        TLCLogger.log("onGetMoreFacetResults", event.data);
        _this.renderFacet(event.data);
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase,
      function (event) {
        _this.toggleFacetDisplay();
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (event) {
        _this.toggleFacetDisplay();
      }
    );
  }
  addListener(eventString, callback) {
    const guid = TLCEventManager.addListener(eventString, callback);
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(eventString, guid));
  }
  removeListeners() {
    
    this.removeListenerFunctions.forEach((remove) => remove());

    this.hasBoundEvents = false;
  }
  toggleFacetDisplay() {
    if (LS2PacSearchDatabaseManager.getCurrentDatabaseConfig().hasFacets) {
      $("#" + this.id)
        .parent()
        .show();
    } else {
      $("#" + this.id)
        .parent()
        .hide();
    }
  }
  emptyList(useNoMoreText) {
    $("#" + this.listId)
      .empty()
      .append(
        "<li>" +
          (useNoMoreText
            ? ApplicationData.language.noFacetsRemaining
            : "&nbsp;") +
          "</li>"
      );
  }
  addEvents() {
    if (this.hasBoundEvents === false) {
      var _this = this;
      /*
        $( elements ).delegate( selector, events, data, handler );
        // \/\/\/
        $( elements ).on( events, selector, data, handler );
      */
      $("#" + this.listId).on("click", "a.mainSection", function (event) {
        var link = $(event.currentTarget);

        if (link.hasClass(LS2PAC_CONSTANTS.CssClasses.open)) {
          link.removeClass(LS2PAC_CONSTANTS.CssClasses.open);
        } else {
          link.addClass(LS2PAC_CONSTANTS.CssClasses.open);
        }

        var facetName = link.attr(_this.constants.facetAttribute);
        var section = $("#" + _this.constants.facetItemsListPrefix + facetName);
        var itemCount = section.find("li").length;

        if (itemCount === 0 && section.is(":visible") === false) {
          var facetToSend = _this.getFacetByName(
            link.attr(_this.constants.facetAttribute)
          );
          facetToSend.slideOpen = true;
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onGetMoreFacetResults,
            { facet: facetToSend }
          );
        } else {
          $(
            "#" + _this.constants.facetItemsListPrefix + facetName
          ).slideToggle();
        }
        return false;
      });

      this.removeListenerFunctions.push(() => $("#" + this.listId).off('click', 'a.mainSection'))

      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.facetBreadCrumbs).on(
        "click",
        "a",
        function (event) {

          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onRemoveFacetFilter,
            { index: parseInt($(event.currentTarget).attr("data-index"), 10) }
          );

          // const url = new URL(window.location.href);
          // const hashParams = new URLSearchParams(url.hash.slice(1));
          // hashParams.set("page", "0");
          // const facetFiltersParam = hashParams.get("facetFilters");
          // try {
          //   const facetIndex = parseInt($(event.currentTarget).attr("data-index"), 10);
          //   const facetFilters = JSON.parse(facetFiltersParam);
          //   facetFilters.splice(facetIndex, 1);
            
          //   hashParams.set("facetFilters", JSON.stringify(facetFilters));
          //   window.location.hash = hashParams.toString();
          // }
          // catch(e){
          //   console.warn("Error parsing facet filters", e);
          // }

          return false;
        }
      );

      this.removeListenerFunctions.push(() => $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.facetBreadCrumbs).off(
        "click",
        "a")
      );

      $("#" + this.listId).on("click", "a.moreFacets", function (event) {
        var link = $(event.currentTarget);
        var facetToSend = _this.getFacetByName(
          link.attr(_this.constants.facetAttribute)
        );
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onGetMoreFacetResults,
          { facet: facetToSend }
        );
        return false;
      });

      this.removeListenerFunctions.push(() => $("#" + this.listId).off('click', 'a.moreFacets'))

      $("#" + this.listId).on("click", "a.applyFacet", function (event) {
        var link = $(event.currentTarget);
        var facetToSend = _this.getFacetByName(
          link.attr(_this.constants.facetAttribute)
        );
        var facetValue =
          facetToSend.facetValues[parseInt(link.attr("data-index"), 10)];

        var facetFilter = {
          facetDisplay: facetValue.displayValue,
          facetValue: facetValue.value,
          facetName: facetToSend.facetName,
        };

        // const url = new URL(window.location.href);
        // const hashParams = new URLSearchParams(url.hash.slice(1));
        // hashParams.set("page", "0");
        // const facetFiltersParam = hashParams.get("facetFilters");
        // try {
        //   const facetFilters = facetFiltersParam ? JSON.parse(facetFiltersParam) : [];
        //   facetFilters.push(facetFilter);
        //   hashParams.set("facetFilters", JSON.stringify(facetFilters));
        //   window.location.hash = hashParams.toString();
        // }
        // catch(e){
        //   console.warn("Error parsing facet filters", e);
        // }
        
        _this.emptyList();

        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onAddFacetFilterToResults,
          { facetFilter: facetFilter }
        );
        return false;
      });

      this.removeListenerFunctions.push(() => $("#" + this.listId).off('click', 'a.applyFacet'))

      this.hasBoundEvents = true;
    }
  }
  getFacetByName(facetName) {
    var facetToSend;
    $.each(this.facetResults, function (index, facetItem) {
      if (facetName == facetItem.facetName) {
        facetToSend = facetItem;
        return false;
      }
    });
    return facetToSend;
  }
}
